import { render, staticRenderFns } from "./feedbackReceivedView.vue?vue&type=template&id=42deef37&scoped=true"
import script from "./feedbackReceivedView.vue?vue&type=script&lang=js"
export * from "./feedbackReceivedView.vue?vue&type=script&lang=js"
import style0 from "./feedbackReceivedView.vue?vue&type=style&index=0&id=42deef37&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42deef37",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42deef37')) {
      api.createRecord('42deef37', component.options)
    } else {
      api.reload('42deef37', component.options)
    }
    module.hot.accept("./feedbackReceivedView.vue?vue&type=template&id=42deef37&scoped=true", function () {
      api.rerender('42deef37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/feedbackStatistics/components/feedbackReceivedView.vue"
export default component.exports